/**
 * Role-based home routing.
 *
 * Customer dashboard for customers; the scanner is the staff "home"
 * (everything starts with a scan); /admin handled in Session 5 for
 * manager/admin.
 */
export const homeForRole = (role) => {
  switch (role) {
    case "staff":
      return "/staff/scanner";
    case "manager":
    case "admin":
      return "/admin/dashboard";
    case "customer":
    default:
      return "/customer/dashboard";
  }
};

/**
 * Where to send a user the moment they finish auth (or hit a
 * <PublicOnlyRoute> already authed). Drives them to /complete-profile
 * first if profile isn't completed.
 */
export const postAuthRedirect = (user) => {
  if (!user) return "/login";
  if (!user.profile_completed) return "/complete-profile";
  return homeForRole(user.role);
};

export default homeForRole;
